import React from 'react';
import PortfolioChart from '../components/PortfolioChart';

const PortfolioPage = () => {
  return (
    <div className="container">
      <h2>📊 Portfolio Dashboard</h2>
      <PortfolioChart />
    </div>
  );
};

export default PortfolioPage;
